module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 32
// module chunks = 0 3 4 6 7 9 10 11 13 14 15 16 20 22 23 24 25 26 27 28 30 33 40